import { create } from "zustand";
import { persist } from "zustand/middleware";

type SessionState = {
  /** A request came back 401 while the app was open. */
  expired: boolean;
  /** Remembered so the unlock sheet only asks for the password. */
  lastEmail: string | null;
  lastName: string | null;
  expire: () => void;
  restore: () => void;
  remember: (email: string, name: string) => void;
};

export const useSession = create<SessionState>()(
  persist(
    (set) => ({
      expired: false,
      lastEmail: null,
      lastName: null,
      expire: () => set({ expired: true }),
      restore: () => set({ expired: false }),
      remember: (email, name) => set({ lastEmail: email, lastName: name }),
    }),
    { name: "kk-session", partialize: (s) => ({ lastEmail: s.lastEmail, lastName: s.lastName }) },
  ),
);
